var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.address)?_c('div',{staticClass:"leading-tight"},[_c('div',{staticClass:"font-medium"},[_vm._v(_vm._s(_vm.address.name))]),_c('div',{staticClass:"text-xs"},[_vm._v(_vm._s(_vm.address.street)+", "+_vm._s(_vm.address.postalCode)+" "+_vm._s(_vm.address.postalName)+", "+_vm._s(_vm.address.countryName))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }